import * as React from 'react';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import { Button, FormControl, IconButton, InputLabel, MenuItem, Popover, Select, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ExpandMore, FormatSize, Numbers, Pin, RadioButtonChecked } from '@mui/icons-material';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

const tipoInput = [
    { tipo: "button", nome: "button" },
    { tipo: "checkbox", nome: "checkbox" },
    { tipo: "color", nome: "color" },
    { tipo: "date", nome: "date" },
    { tipo: "datetime-local", nome: "datetime" },
    { tipo: "email", nome: "email" },
    { tipo: "file", nome: "file" },
    { tipo: "hidden", nome: "hidden" },
    { tipo: "image", nome: "image" },
    { tipo: "month", nome: "month" },
    { tipo: "number", nome: "number" },
    { tipo: "password", nome: "password" },
    { tipo: "radio", nome: "radio" },
    { tipo: "range", nome: "range" },
    { tipo: "reset", nome: "reset" },
    { tipo: "search", nome: "search" },
    { tipo: "submit", nome: "submit" },
    { tipo: "tel", nome: "tel" },
    { tipo: "text", nome: "text" },
    { tipo: "time", nome: "time" },
    { tipo: "url", nome: "url" },
    { tipo: "week", nome: "week" }
]

export default function InpultEditorPopover(props) {
    const { setElemento, textField } = props;
    const [tipo, setTipo] = React.useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    React.useEffect(() => {
        setTipo(textField.getAttribute('type'))
    }, [textField]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeTipo = (e) => {
        const novoTipo = e.target.value;
        setTipo(novoTipo);
        // Se temos um textField selecionado, modifica ele
        if (textField) {
            // Modifica o tipo do input existente
            textField.setAttribute('type', novoTipo);

            // Atualiza visualmente se necessário
            textField.type = novoTipo;
        }

        handleClose(); // Fecha o popover após a alteração

    };



    return (
        <React.Fragment>
            <Tooltip title="TextFild">
                <IB
                    color={textField ? 'primary' : 'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <TextFieldsIcon />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Stack direction="row">
                    {/* <Tooltip title="Formata Texto">
                        <IB
                            onClick={e => console.log(e.currentTarget)}
                        >
                            <Pin />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Formata Texto">
                        <IB
                            onClick={e => console.log(e.currentTarget)}
                        >
                            <RadioButtonChecked />
                        </IB>
                    </Tooltip> */}
                    <Typography >Tipo: </Typography>
                    <Tooltip title="Font-family">

                        <FormControl sx={{ width: 200 }} >
                            {/* <InputLabel id="demo-simple-select-label">Tipo</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={tipo || ""}
                                // label="Tipo"
                                onChange={handleChangeTipo}
                            >
                                {tipoInput.map((m, i) => (
                                    <MenuItem key={`${m.tipo}_${i}`} value={m.tipo}>{m.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Tooltip>
                </Stack>
            </Popover>
        </React.Fragment>
    )
}